import React, { useMemo, useRef } from "react";
import { func, string, array } from "prop-types";
import { allSelectedFacetIds } from "../../../common/dynamicSearch.js";
import uniqueId from "lodash.uniqueid";

import Icon from "../../Icon/Icon.jsx";

const propTypes = {
  label: string,
  clearLabel: string,
  facets: array,
  onClearItem: func,
  onClearAll: func,
};

const SelectedFilters = (props) => {
  const { label, clearLabel, facets, onClearItem, onClearAll } = props;

  const labelId = useRef(uniqueId("selected-filter-label-"));

  const pills = useMemo(() => {
    if (facets) {
      return allSelectedFacetIds(facets);
    } else {
      return [];
    }
  }, [facets]);

  if (pills.length < 1) {
    return null;
  }

  pills.sort((a, b) => (a.value < b.value ? -1 : 1));

  return (
    <section className="selected-filters">
      {label && (
        <div className="selected-filters__label" id={labelId.current}>
          {label}
        </div>
      )}
      {pills?.length > 0 && (
        <ul
          className="selected-filters__list"
          aria-labelledby={label ? labelId.current : undefined}
        >
          {pills.map((item, index) => (
            <li key={index} className="selected-filters__item">
              <button
                className="selected-filters__pill btn btn--secondary btn--small"
                aria-label={`remove ${item.facetName} filter`}
                onClick={() => {
                  onClearItem(item.facetGroupId, item.facetValue);
                }}
              >
                <span>{item.facetName}</span>
                <Icon iconName="close" />
              </button>
            </li>
          ))}
          {pills?.length > 1 && onClearAll && (
            <li className="selected-filters__item">
              <button
                className="selected-filters__pill btn btn--primary btn--small"
                onClick={() => {
                  onClearAll();
                }}
              >
                <span>{clearLabel || "Clear"}</span>
                <Icon iconName="close" />
              </button>
            </li>
          )}
        </ul>
      )}
    </section>
  );
};
SelectedFilters.propTypes = propTypes;
export default SelectedFilters;
